import { useMemo } from 'react';

export const useValueVariant = (value: number, lowerIsBetter?: boolean) => {
  return useMemo(() => {
    if (lowerIsBetter) {
      return value <= 0.2 ? 'success' : value <= 0.7 ? 'secondary' : 'warning';
    } else {
      return value >= 0.8 ? 'success' : value >= 0.3 ? 'secondary' : 'warning';
    }
  }, [lowerIsBetter, value]);
};
